import React from "react"
import Home from './pages/Home/Home.jsx'
// import { BrowserRouter, Routes, Route } from "react-router-dom"
// import Login from './pages/Login/Login.jsx'
// // import { BrowserRouter } from 'react-router-dom';

const App = () => {
  return (
    <div>
       <Home/>
    </div>
  )
}
export default App